import {CartFragmentFragment} from '@shopify/hydrogen/components/CartProvider/graphql/CartFragment';
import {useMemo} from 'react';
import {CUSTOM_ATTRIBUTES_KEYS} from '~/lib/const';

export function useProductCartItems(
  lines: CartFragmentFragment['lines']['edges'][1]['node'][],
) {
  return useMemo(() => {
    return lines.filter((line) => {
      const isAddon = line.attributes.find(
        (attr) =>
          attr.key === CUSTOM_ATTRIBUTES_KEYS.ADDON_PARENT_PRODUCT_VARIANT_ID,
      );

      const isMainBundle = line.attributes.find(
        (attr) => attr.key === '_bundle_main', //CUSTOM_ATTRIBUTES_KEYS.BUNDLE_ATTRIBUTE_MAIN,
      );

      const isBundlePart = line.attributes.find(
        (attr) => attr.key === '_bundle_title', //CUSTOM_ATTRIBUTES_KEYS.BUNDLE_ATTRIBUTE_BUNDLE,
      );

      return !isAddon && (isMainBundle || (!isMainBundle && !isBundlePart));
    });
  }, [lines]);
}
